const SvgModernize1 = (props) => (
  <>
    <path fill="none" stroke={props.p50} strokeMiterlimit={10} d="M192 160 96 64 0 160h192z" />
    <path fill="none" stroke={props.p50} strokeMiterlimit={10} d="m192 224-96-96-96 96h192z" />
    <path fill="none" stroke={props.p50} strokeMiterlimit={10} d="m192 288-96-96-96 96h192zM192 96 96 0 0 96h192z" />
    <circle cy={192} r={1} fill={props.p50} />
    <circle cx={16} cy={192} r={1} fill={props.p50} />
    <circle cx={32} cy={192} r={1} fill={props.p50} />
    <circle cx={48} cy={192} r={1} fill={props.p50} />
    <circle cx={64} cy={192} r={1} fill={props.p50} />
    <circle cx={80} cy={192} r={1} fill={props.p50} />
    <circle cx={96} cy={192} r={1} fill={props.p50} />
    <circle cx={112} cy={192} r={1} fill={props.p50} />
    <circle cx={128} cy={192} r={1} fill={props.p50} />
    <circle cx={144} cy={192} r={1} fill={props.p50} />
    <circle cx={160} cy={192} r={1} fill={props.p50} />
    <circle cx={176} cy={192} r={1} fill={props.p50} />
    <circle cx={192} cy={192} r={1} fill={props.p50} />
    <circle cy={208} r={1} fill={props.p50} />
    <circle cx={16} cy={208} r={1} fill={props.p50} />
    <circle cx={32} cy={208} r={1} fill={props.p50} />
    <circle cx={48} cy={208} r={1} fill={props.p50} />
    <circle cx={64} cy={208} r={1} fill={props.p50} />
    <circle cx={80} cy={208} r={1} fill={props.p50} />
    <circle cx={96} cy={208} r={1} fill={props.p50} />
    <circle cx={112} cy={208} r={1} fill={props.p50} />
    <circle cx={128} cy={208} r={1} fill={props.p50} />
    <circle cx={144} cy={208} r={1} fill={props.p50} />
    <circle cx={160} cy={208} r={1} fill={props.p50} />
    <circle cx={176} cy={208} r={1} fill={props.p50} />
    <circle cx={192} cy={208} r={1} fill={props.p50} />
    <circle cy={224} r={1} fill={props.p50} />
    <circle cx={16} cy={224} r={1} fill={props.p50} />
    <circle cx={32} cy={224} r={1} fill={props.p50} />
    <circle cx={48} cy={224} r={1} fill={props.p50} />
    <circle cx={64} cy={224} r={1} fill={props.p50} />
    <circle cx={80} cy={224} r={1} fill={props.p50} />
    <circle cx={96} cy={224} r={1} fill={props.p50} />
    <circle cx={112} cy={224} r={1} fill={props.p50} />
    <circle cx={128} cy={224} r={1} fill={props.p50} />
    <circle cx={144} cy={224} r={1} fill={props.p50} />
    <circle cx={160} cy={224} r={1} fill={props.p50} />
    <circle cx={176} cy={224} r={1} fill={props.p50} />
    <circle cx={192} cy={224} r={1} fill={props.p50} />
    <circle cy={240} r={1} fill={props.p50} />
    <circle cx={16} cy={240} r={1} fill={props.p50} />
    <circle cx={32} cy={240} r={1} fill={props.p50} />
    <circle cx={48} cy={240} r={1} fill={props.p50} />
    <circle cx={64} cy={240} r={1} fill={props.p50} />
    <circle cx={80} cy={240} r={1} fill={props.p50} />
    <circle cx={96} cy={240} r={1} fill={props.p50} />
    <circle cx={112} cy={240} r={1} fill={props.p50} />
    <circle cx={128} cy={240} r={1} fill={props.p50} />
    <circle cx={144} cy={240} r={1} fill={props.p50} />
    <circle cx={160} cy={240} r={1} fill={props.p50} />
    <circle cx={176} cy={240} r={1} fill={props.p50} />
    <circle cx={192} cy={240} r={1} fill={props.p50} />
    <circle cy={256} r={1} fill={props.p50} />
    <circle cx={16} cy={256} r={1} fill={props.p50} />
    <circle cx={32} cy={256} r={1} fill={props.p50} />
    <circle cx={48} cy={256} r={1} fill={props.p50} />
    <circle cx={64} cy={256} r={1} fill={props.p50} />
    <circle cx={80} cy={256} r={1} fill={props.p50} />
    <circle cx={96} cy={256} r={1} fill={props.p50} />
    <circle cx={112} cy={256} r={1} fill={props.p50} />
    <circle cx={128} cy={256} r={1} fill={props.p50} />
    <circle cx={144} cy={256} r={1} fill={props.p50} />
    <circle cx={160} cy={256} r={1} fill={props.p50} />
    <circle cx={176} cy={256} r={1} fill={props.p50} />
    <circle cx={192} cy={256} r={1} fill={props.p50} />
    <circle cy={272} r={1} fill={props.p50} />
    <circle cx={16} cy={272} r={1} fill={props.p50} />
    <circle cx={32} cy={272} r={1} fill={props.p50} />
    <circle cx={48} cy={272} r={1} fill={props.p50} />
    <circle cx={64} cy={272} r={1} fill={props.p50} />
    <circle cx={80} cy={272} r={1} fill={props.p50} />
    <circle cx={96} cy={272} r={1} fill={props.p50} />
    <circle cx={112} cy={272} r={1} fill={props.p50} />
    <circle cx={128} cy={272} r={1} fill={props.p50} />
    <circle cx={144} cy={272} r={1} fill={props.p50} />
    <circle cx={160} cy={272} r={1} fill={props.p50} />
    <circle cx={176} cy={272} r={1} fill={props.p50} />
    <circle cx={192} cy={272} r={1} fill={props.p50} />
    <circle cy={288} r={1} fill={props.p50} />
    <circle cx={16} cy={288} r={1} fill={props.p50} />
    <circle cx={32} cy={288} r={1} fill={props.p50} />
    <circle cx={48} cy={288} r={1} fill={props.p50} />
    <circle cx={64} cy={288} r={1} fill={props.p50} />
    <circle cx={80} cy={288} r={1} fill={props.p50} />
    <circle cx={96} cy={288} r={1} fill={props.p50} />
    <circle cx={112} cy={288} r={1} fill={props.p50} />
    <circle cx={128} cy={288} r={1} fill={props.p50} />
    <circle cx={144} cy={288} r={1} fill={props.p50} />
    <circle cx={160} cy={288} r={1} fill={props.p50} />
    <circle cx={176} cy={288} r={1} fill={props.p50} />
    <circle cx={192} cy={288} r={1} fill={props.p50} />
    <circle cy={304} r={1} fill={props.p50} />
    <circle cx={16} cy={304} r={1} fill={props.p50} />
    <circle cx={32} cy={304} r={1} fill={props.p50} />
    <circle cx={48} cy={304} r={1} fill={props.p50} />
    <circle cx={64} cy={304} r={1} fill={props.p50} />
    <circle cx={80} cy={304} r={1} fill={props.p50} />
    <circle cx={96} cy={304} r={1} fill={props.p50} />
    <circle cx={112} cy={304} r={1} fill={props.p50} />
    <circle cx={128} cy={304} r={1} fill={props.p50} />
    <circle cx={144} cy={304} r={1} fill={props.p50} />
    <circle cx={160} cy={304} r={1} fill={props.p50} />
    <circle cx={176} cy={304} r={1} fill={props.p50} />
    <circle cx={192} cy={304} r={1} fill={props.p50} />
    <circle cy={320} r={1} fill={props.p50} />
    <circle cx={16} cy={320} r={1} fill={props.p50} />
    <circle cx={32} cy={320} r={1} fill={props.p50} />
    <circle cx={48} cy={320} r={1} fill={props.p50} />
    <circle cx={64} cy={320} r={1} fill={props.p50} />
    <circle cx={80} cy={320} r={1} fill={props.p50} />
    <circle cx={96} cy={320} r={1} fill={props.p50} />
    <circle cx={112} cy={320} r={1} fill={props.p50} />
    <circle cx={128} cy={320} r={1} fill={props.p50} />
    <circle cx={144} cy={320} r={1} fill={props.p50} />
    <circle cx={160} cy={320} r={1} fill={props.p50} />
    <circle cx={176} cy={320} r={1} fill={props.p50} />
    <circle cx={192} cy={320} r={1} fill={props.p50} />
    <circle cy={336} r={1} fill={props.p50} />
    <circle cx={16} cy={336} r={1} fill={props.p50} />
    <circle cx={32} cy={336} r={1} fill={props.p50} />
    <circle cx={48} cy={336} r={1} fill={props.p50} />
    <circle cx={64} cy={336} r={1} fill={props.p50} />
    <circle cx={80} cy={336} r={1} fill={props.p50} />
    <circle cx={96} cy={336} r={1} fill={props.p50} />
    <circle cx={112} cy={336} r={1} fill={props.p50} />
    <circle cx={128} cy={336} r={1} fill={props.p50} />
    <circle cx={144} cy={336} r={1} fill={props.p50} />
    <circle cx={160} cy={336} r={1} fill={props.p50} />
    <circle cx={176} cy={336} r={1} fill={props.p50} />
    <circle cx={192} cy={336} r={1} fill={props.p50} />
    <circle cy={352} r={1} fill={props.p50} />
    <circle cx={16} cy={352} r={1} fill={props.p50} />
    <circle cx={32} cy={352} r={1} fill={props.p50} />
    <circle cx={48} cy={352} r={1} fill={props.p50} />
    <circle cx={64} cy={352} r={1} fill={props.p50} />
    <circle cx={80} cy={352} r={1} fill={props.p50} />
    <circle cx={96} cy={352} r={1} fill={props.p50} />
    <circle cx={112} cy={352} r={1} fill={props.p50} />
    <circle cx={128} cy={352} r={1} fill={props.p50} />
    <circle cx={144} cy={352} r={1} fill={props.p50} />
    <circle cx={160} cy={352} r={1} fill={props.p50} />
    <circle cx={176} cy={352} r={1} fill={props.p50} />
    <circle cx={192} cy={352} r={1} fill={props.p50} />
    <circle cy={368} r={1} fill={props.p50} />
    <circle cx={16} cy={368} r={1} fill={props.p50} />
    <circle cx={32} cy={368} r={1} fill={props.p50} />
    <circle cx={48} cy={368} r={1} fill={props.p50} />
    <circle cx={64} cy={368} r={1} fill={props.p50} />
    <circle cx={80} cy={368} r={1} fill={props.p50} />
    <circle cx={96} cy={368} r={1} fill={props.p50} />
    <circle cx={112} cy={368} r={1} fill={props.p50} />
    <circle cx={128} cy={368} r={1} fill={props.p50} />
    <circle cx={144} cy={368} r={1} fill={props.p50} />
    <circle cx={160} cy={368} r={1} fill={props.p50} />
    <circle cx={176} cy={368} r={1} fill={props.p50} />
    <circle cx={192} cy={368} r={1} fill={props.p50} />
    <circle cy={384} r={1} fill={props.p50} />
    <circle cx={16} cy={384} r={1} fill={props.p50} />
    <circle cx={32} cy={384} r={1} fill={props.p50} />
    <circle cx={48} cy={384} r={1} fill={props.p50} />
    <circle cx={64} cy={384} r={1} fill={props.p50} />
    <circle cx={80} cy={384} r={1} fill={props.p50} />
    <circle cx={96} cy={384} r={1} fill={props.p50} />
    <circle cx={112} cy={384} r={1} fill={props.p50} />
    <circle cx={128} cy={384} r={1} fill={props.p50} />
    <circle cx={144} cy={384} r={1} fill={props.p50} />
    <circle cx={160} cy={384} r={1} fill={props.p50} />
    <circle cx={176} cy={384} r={1} fill={props.p50} />
    <circle cx={192} cy={384} r={1} fill={props.p50} />
  </>
);

export default SvgModernize1;
